import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { Checkbox } from "@mantine/core";
/** SDS checkbox built on Mantine; checked/hover/disabled styling comes from the app-wide theme. */
export function FormCheckbox(props) {
  return /*#__PURE__*/React.createElement(Checkbox, _extends({
    size: "sm",
    radius: "sm"
  }, props));
}